import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import TitledTextarea from "components/TitledTextarea";

import styles from "forms/forms.css";

const TextareaField = ({
  border,
  field: { name, onChange, value, ...fieldProps },
  form: { errors, setFieldValue, submitCount },
  inset,
  isEdit,
  label,
  onEdit,
  placeholder,
  rows,
}) => (
  <div className={cx(styles.field, { [styles.inset]: inset })}>
    <TitledTextarea
      border={border}
      isEdit={isEdit}
      isRequired={!!submitCount && errors[name]}
      maxRows={Math.max(3, rows)}
      minRows={rows}
      onChange={(v) => setFieldValue(name, v)}
      onEdit={onEdit}
      placeholder={placeholder}
      title={label}
      value={value}
      {...fieldProps}
    />
  </div>
);

TextareaField.propTypes = {
  border: PropTypes.oneOf(["bottom", "left"]),
  field: PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    setFieldValue: PropTypes.func,
    submitCount: PropTypes.number,
  }),
  isEdit: PropTypes.bool,
  inset: PropTypes.bool,
  onEdit: PropTypes.func,
  label: PropTypes.string,
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
};

TextareaField.defaultProps = {
  isEdit: true,
};

export default TextareaField;
